const courseSubmitFormValidation = () => {

  const form = document.getElementById('extra-info-form');
  const payButton = document.getElementById('pay-button');

  // Fonction pour vérifier si tous les champs sont remplis
  const checkFormFields = () => {
    const firstName = document.getElementById('first_name')?.value.trim();
    const lastName = document.getElementById('last_name')?.value.trim();
    const email = document.getElementById('email')?.value.trim();
    const phoneNumber = document.getElementById('phone_number')?.value.trim();

    // Regex for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Vérifiez si tous les champs sont remplis et valides
    return firstName && lastName && emailRegex.test(email) && phoneNumber;
  };

  // Vérifier si la case FAQ a été cochée
  const checkFaqConfirmation = () => {
    const faqCheckbox = document.getElementById('faq-read-confirmation');
    return faqCheckbox && faqCheckbox.checked;
  };

  // Fonction pour mettre à jour l'état du bouton
  const updatePayButtonState = () => {
    if (payButton) {
      if (checkFormFields() && checkFaqConfirmation()) {
        payButton.disabled = false;
        payButton.classList.remove('btn-secondary', 'btn-disabled');
      } else {
        payButton.disabled = true;
        payButton.classList.add('btn-disabled');
      }
    }
  };

  // Gérer les événements d'entrée pour chaque champ
  if (form) {
    form.addEventListener('input', updatePayButtonState);
    form.addEventListener('change', updatePayButtonState);
  }

  // Écouter aussi la case FAQ
  const faqCheckbox = document.getElementById('faq-read-confirmation');
  if (faqCheckbox) {
    faqCheckbox.addEventListener('change', updatePayButtonState);
  }

  // Désactivez le bouton lors de l'initialisation du script
  updatePayButtonState();
};
  
export { courseSubmitFormValidation };
